<template>
  <div class="page">
    <div class="content_box">
      <header>
        <div class="head_main">
          <div class="head_left">
            <div class="headImgWrap">
              <div class="head_img">
                <img
                  :src="
                    personInfo.head_image
                      ? personInfo.head_image
                      : require('../../assets/imgs/admin.png')
                  "
                  alt=""
                />
              </div>
            </div>
            <div class="head_info">
              <div
                class="info_item user_name"
                v-if="personInfo && personInfo.nickname"
              >
                {{ personInfo.nickname }}
              </div>
              <div
                class="info_item other_name"
                v-if="personInfo && personInfo.account"
              >
                {{h5Config.textCfg.idNum}}：{{ personInfo.account }}
              </div>
              <div
                class="info_item other_name"
                v-if="personInfo && personInfo.course_type_name"
              >
                {{h5Config.textCfg.fromType}}： {{ personInfo.course_type_name }}
              </div>

              <div class="info_item other_name">累计时长：{{ practiceH }}</div>
            </div>
          </div>
          <div class="setting" @click="jumpToSetting">
            <van-icon name="setting-o" />
          </div>
        </div>
        <div class="use_time">
          <span class="left_time">可用剩余时长（小时）</span>
          <span class="done_time">{{ canUseH }}</span>
        </div>
      </header>
      <div class="myOrder">
        <div class="myOrder_tit">
          <span class="my_order_text">我的预约</span>
          <span class="history_order_text" @click="historyOrder"
            >历史预约<van-icon name="arrow"
          /></span>
        </div>
        <div class="fixed_list">
          <div v-if="designateList.length > 0" class="designate-parent">
            <div class="designate-list-title">固定指派</div>
            <div
              class="designate-item"
              v-for="item in designateList"
              :key="item.id"
              @click="viewAppointment(item)"
            >
              <div class="designate-item-address">{{ item.set_address }}</div>
              <van-icon class="fixedImg" name="arrow" />
            </div>
          </div>
        </div>
        <div class="myOrder_list" v-if="haveOrderList.length > 0">
          <div class="classItem" v-for="item in haveOrderList" :key="item.id" @click="viewAppointment(item)">
            <template>
              <div>
                <div class="floor">{{ item.set_address }}</div>
                <div class="time">{{ item.set_useTime }}</div>
                <div class="isClassing">
                  <span
                    v-if="item.set_ShowStatus == 1"
                    class="status-text-parent"
                  >
                    <span class="status-text" style="color: #44d06e"
                      >预约未开始</span
                    >
                  </span>
                  <span
                    v-if="item.set_ShowStatus == 2"
                    class="status-text-parent"
                  >
                    <span class="status-text" style="color: #ffa405"
                      >预约已开始</span
                    >
                    <span class="status-text-up-hint">请及时签到</span>
                  </span>
                  <span
                    v-if="item.set_ShowStatus == 3"
                    class="status-text-parent"
                  >
                    <span class="status-text" style="color: #ffa405"
                      >预约已开始 · 已签到</span
                    >
                  </span>
                  <span
                    v-if="item.set_ShowStatus == 4"
                    class="status-text-parent"
                  >
                    <span class="status-text" style="color: #999999"
                      >预约已结束 · 已签到<span style="color: #ffa405">
                        · 已签退</span
                      ></span
                    >
                  </span>
                  <span
                    v-if="item.set_ShowStatus == 5"
                    class="status-text-parent"
                  >
                    <span class="status-text" style="color: #999999"
                      >预约已结束 · 已签到<span style="color: #ff2b05">
                        · 未按时签退</span
                      ></span
                    >
                  </span>
                  <span
                    v-if="item.set_ShowStatus == 6"
                    class="status-text-parent"
                  >
                    <span class="status-text" style="color: #999999"
                      >预约已结束<span style="color: #ff2b05">
                        · 未按时签到</span
                      ></span
                    >
                  </span>
                  <span
                    v-if="item.set_ShowStatus == 7"
                    class="status-text-parent"
                  >
                    <span class="status-text" style="color: #999999"
                      >预约已结束 · 预约取消</span
                    >
                  </span>
                </div>
              </div>
              <div class="otherStateBox">
                 <!-- 预约的审批状态 -->
          <div class="orderStateBox" v-if="book_audit_type&&item.apply_status===1">
            <i class="orderStateIcon orderStateIconNormal"></i>
            <span class="orderStateText orderStateTextNormal"> 待审批</span>
          </div>
          <div class="orderStateBox" v-if="book_audit_type&&item.apply_status===2">
            <i class="orderStateIcon orderStateIconNo"></i>
            <span class="orderStateText orderStateTextNo"> 审批拒绝</span>
          </div>
          <div class="orderStateBox" v-if="book_audit_type&&item.apply_status===3">
            <i class="orderStateIcon orderStateIconOk"></i>
            <span class="orderStateText orderStateTextOk"> 审批同意</span>
          </div>
                <div v-if="settingDown">
                  <div
                    v-if="item.set_ShowStatus == 2"
                    class="iconfont icon-erweima"
                    style="color: #60b3ff; font-size: 25px;"
                  />
                  <div
                    v-if="item.set_ShowStatus == 3 || item.set_ShowStatus == 5"
                    class="down-piano-parent"
                  >
                    <div
                      @click.stop="downPiano(item)"
                      :style="item.set_ShowStatus == 5 ? 'color:#999;' : ''"
                    >
                      签退
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

        </div>
        <div
          v-if="haveOrderList.length === 0 && designateList.length === 0"
          class="empty-appointment-parent"
        >
          <div
            class="iconfont icon-empty-copy"
            style="color: #d8d8d8; font-size: 108rpx"
          />
          <div class="empty-appointment-hint">这里还是空的，快去预约吧</div>
        </div>
      </div>

      <div class="more_tit">更多操作</div>

      <div class="use_record">
        <div class="use_tit" v-if="false">
          <div class="use_left">
            <van-icon class="iconfont icon-chongzhi" />
          </div>
          <div class="use_right">
            <span class="history_order_text">充值记录</span>
            <span class="history_look" @click="rechargeRecord"
              ><van-icon name="arrow"
            /></span>
          </div>
        </div>
        <!-- todo 提交时需要打开if判断 -->
        <div class="use_tit" v-if="h5Config.funCfg.openMyCourse" @click="toCourse">
          <div class="use_left">
            <van-icon class="iconfont icon-kecheng" />
          </div>
          <div class="use_right">
            <span class="history_order_text">课程</span>
            <span class="history_look"><van-icon name="arrow" /></span>
          </div>
        </div>
        <div class="use_tit" v-if="h5Config.funCfg.openFace" @click="viewMyFace" >
          <div class="use_left">
            <van-icon class="iconfont icon-renlianxinxi" />
          </div>
          <div class="use_right">
            <span class="history_order_text">人脸信息</span>
            <span class="history_look"><van-icon name="arrow" /></span>
          </div>
        </div>
        <div class="use_tit" v-if="!h5Config.funCfg.hideWhiteList" @click="whiteNameList">
          <div class="use_left">
            <van-icon class="iconfont icon-baimingdan" />
          </div>
          <div class="use_right">
            <span class="history_order_text">白名单</span>
            <span class="history_look"><van-icon name="arrow" /></span>
          </div>
        </div>
        <div class="use_tit" @click="historyLook">
          <div class="use_left">
            <van-icon class="iconfont icon-Q_rz-2" />
          </div>
          <div class="use_right">
            <span class="history_order_text">{{h5Config.textCfg.roomName}}使用记录</span>
            <span class="history_look"><van-icon name="arrow" /></span>
          </div>
        </div>
<!--        <div class="use_tit" @click="setAirCondition">-->
<!--          <div class="use_left">-->
<!--            <van-icon class="icon iconfont icon-banpaih5yaokongqi"/>-->
<!--          </div>-->
<!--          <div class="use_right">-->
<!--            <span class="history_order_text"-->
<!--            >物联设置</span-->
<!--            >-->
<!--            <span style="margin-right: auto;margin-left: 10px;font-size: 14px;color: #c0c0c0">签到后自动按设置开启</span>-->
<!--            <span class="history_look"><van-icon name="arrow" /></span>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import { Dialog, Toast } from 'vant'
import { mapGetters } from 'vuex'

export default {

  data () {
    return {
      haveOrderList: [],
      designateList: [],
      isTeacher: false,
      canUseH: 0,
      practiceH: 0,
      personInfo: {
        head_image: '',
        nickname: '',
        account: '',
        course_type_name: ''
      },
      timeInterval: null,
      settingDown: false,
      showCourse: false,
      book_audit_type: false // web端的预约审批配置

    }
  },
  mounted () {
    Toast.loading({
      message: '加载中...',
      forbidClick: true
    })
    this.getHaveOrderList()
    this.getPersonalInfo()
    this.isTeacher = utils.isTeacher()
    this.getUpDownSetting()
  },
  computed: {
    // openMyCourse: function () {
    //   const h5Config = this.$store.state.h5Config
    //   if (h5Config && h5Config.h5Config && h5Config.h5Config.funCfg) {
    //     return this.$store.state.h5Config.h5Config.funCfg.openMyCourse
    //   } else {
    //     return false
    //   }
    // },
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    // 查看人脸信息
    viewMyFace () {
      this.$router.push('/myFaceInfo')
    },
    // 白名单
    whiteNameList () {
      this.$router.push('/whiteNameList')
    },

    // 扫一扫
    scanQRCode () {
      this.$router.push('/qrCodeWrap')
    },
    getUpDownSetting () {
      const para = {

      }
      api
        .axiosRequest(api.urlList.getUpDownSetting, para)
        .then((res) => {
          if (res && res.code === common.resCode.OK) {
            if (!res.model ||
              res.model === 1 ||
              res.model === 3) {
              this.settingDown = true
            }
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },

    downPiano (item) {
      if (item.set_ShowStatus === 5) {
        Dialog.alert({
          title: '提示',
          message: '预约结束，已超过签退时间'
        }).then(() => {
          // on close
        })
      } else {
        this.$router.push({
          path: '/appointmentDetails',
          query: {
            bookId: item.id,
            downPiano: true,
            roomId: item.room_id

          }
        })
      }
    },
    // 充值记录查看
    rechargeRecord () {

    },
    // 课程记录查看
    toCourse () {
      this.$router.push('/course')
    },
    transformationHour (allhour) {
      if (allhour) {
        const hour = Number.parseInt(allhour)
        const minute = Math.round(allhour % 1 * 60)
        allhour = ''

        if (hour > 0) {
          allhour += hour + '小时'
        }
        if (minute > 0) {
          allhour += minute + '分钟'
        }
        if (!allhour) {
          allhour = 0
        }
      } else {
        allhour = 0
      }
      return allhour
    },
    getPersonalInfo () {
      const para = {}
      api
        .axiosRequest(api.urlList.getPersonalInfo, para)
        .then((res) => {
          if (res && res.code === common.resCode.OK) {
            this.personInfo = res
            this.canUseH = res.can_use_h
            this.practiceH = this.transformationHour(res.practice_h)
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    historyOrder () {
      this.$router.push('/historyOrder')
    },
    setAirCondition () {
      this.$router.push('/setAirCondition')
    },
    historyLook () {
      this.$router.push('/useRecord')
    },
    jumpToSetting () {
      this.$router.push('./setting')
    },
    // 获取未来预约数据
    getHaveOrderList () {
      const designateList = []
      const curTime = new Date()
      curTime.setHours(0)
      curTime.setMinutes(0)
      curTime.setSeconds(0)
      const para = {
        start_time: utils.formatTimeInterval(curTime, '-', ':'),
        book_audit_type: true
      }
      api
        .axiosRequest(api.urlList.historyOrder, para)
        .then((res) => {
          Toast.clear()
          console.log('未来预约数据', res)
          if (res && res.code === common.resCode.OK) {
            res.list.forEach((item) => {
              let startTime = ''
              let endTime = ''

              startTime = utils.formatDate(item.begin_time)
              endTime = utils.formatDate(item.end_time)
              item.set_useTime = utils.formatTimeMDChinese(startTime) + ' ' + utils.formatTimeHourMinutes(startTime) + ' - ' + utils.formatTimeHourMinutes(endTime)
              item.set_address = item.type_name + ' ' + item.building_no + ' ' + item.name
              item.set_startTime = startTime.getTime()
              item.set_endTime = endTime.getTime()

              // 获取固定指派的列表
              if (item.status === 7) {
                designateList.push(item)
              }
            })
            // 预约列表不包括固定指派数据
            this.haveOrderList = res.list.filter(item => item.status !== 7)
            this.designateList = designateList
            if (res.book_audit_type) {
              this.book_audit_type = true
            } else {
              this.book_audit_type = false
            }

            this.refreshListStatus()
          } else {
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
    },
    // 点击固定指派行
    viewAppointment (item) {
      this.$router.push({
        path: '/appointmentDetails',
        query: {
          bookId: item.id,
          roomId: item.room_id,
          showTime: item.set_useTime,
          showAddress: item.set_address,
          startTime: item.begin_time,
          endTime: item.end_time,
          set_ShowStatus: item.set_ShowStatus,
          apply_status: item.apply_status
        }
      })
    },
    // 预约课程状态
    refreshListStatus () {
      const list = JSON.parse(JSON.stringify(this.haveOrderList))
      const curTime = new Date().getTime()
      let downlimit = 0
      try {
        const configData = JSON.parse(localStorage.getItem(common.keyConfigInfo))
        if (configData && configData.allow_delay_down_minutes) {
          downlimit = configData.allow_delay_down_minutes * 60 * 1000
        }
      } catch (e) {
        console.log(e)
      }
      let dd
      let timestatus
      // 1 预约未开始  2 已开始，但未签到  3 已开始，已签到
      // 4 到时间，已签退  5 到时间，未按时签退
      // 6 已结束，未签到  7 已结束，预约取消
      let newStatus
      for (const key in list) {
        dd = list[key]
        if (curTime < dd.set_startTime) {
          // 未开始
          timestatus = 1
        } else if (curTime >= dd.set_startTime && curTime < dd.set_endTime) {
          // 可签到时间段，签到后可签退时间段
          timestatus = 2
        } else if (curTime >= dd.set_endTime && curTime < (dd.set_endTime + downlimit)) {
          // 最后的签退时间段
          timestatus = 3
        } else {
          // 结束
          timestatus = 4
        }

        if (dd.status === 1) {
          if (timestatus === 1) {
            newStatus = 1
          } else if (timestatus === 2) {
            newStatus = 2
          } else {
            newStatus = 6
          }
        } else if (dd.status === 2 || dd.status === 5) {
          if (timestatus <= 3) {
            newStatus = 3
          } else {
            newStatus = 5
          }
        } else if (dd.status === 3) {
          newStatus = 7
        } else if (dd.status === 6) {
          newStatus = 4
        } else {
          newStatus = 100
        }
        dd.set_ShowStatus = newStatus
      }
      this.haveOrderList = JSON.parse(JSON.stringify(list))
    }

  }
}
</script>
<style scoped lang="scss">
@import '../../assets/css/constant.scss';
.page {
  width: 100%;
  padding-bottom: 3.75rem;

  .content_box {
    // padding: 0 16px;
    width: 100%;
    //   height: 100%;
    overflow-x: hidden;
    header {
      padding: 0.5rem 1rem 0 1rem;
      //   height: 10rem;
      display: flex;
      flex-direction: column;
      background-color: $parmaryColor;
      .head_main {
        display: flex;
        justify-content: space-between;

        .head_left {
          width: 100%;
          // width: 90%;
          height: 5.5rem;
          //   height: 120px;
          padding: 1rem 0;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .headImgWrap {
            // width: 50%;
            height: 100%;
            display: flex;
            align-items: flex-start;

            .head_img {
              width: 3.375rem;
              height: 3.375rem;
              border-radius: 1.5625rem;
              // border: 0.0625rem solid;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .head_info {
            // width: 50%;
            height: 100%;
            margin-left: 1.75rem;
            .info_item {
              text-align: left;
              color: white;
              font-size: 0.75rem;
            }
            .other_name {
              margin-top: 0.375rem;
            }
            .user_name {
              font-size: 1.375rem;
            }
          }
        }
        .setting {
          // width: 10%;
          color: white;
          font-size: 1.25rem;
        }
      }
      .use_time {
        padding: 0 0.125rem;
        height: 50px;
        border-radius: 6px 6px 0 0;
        background-color: #e7f3ff;
        display: flex;
        align-items: center;
        justify-content: center;
        .left_time {
          font-size: 12px;
          color: #414141;
        }
        .done_time {
          font-size: 18px;
          color: #333;
          font-weight: 550;
        }
      }
    }
    .myOrder {
      padding: 1rem;
      //   margin-top: ;
      .myOrder_tit {
        display: flex;
        justify-content: space-between;
        .my_order_text {
          font-size: 18px;
          font-weight: 550;
          color: #333;
        }
        .history_order_text {
          color: #919191;
          font-size: 14px;
        }
      }
      .fixed_list {
        padding-top: 1rem;
        .designate-parent {
          box-sizing: border-box;
          padding: 0 0.75rem 1rem 0.75rem;
          // margin: 0 0.875rem 0.75rem 0.875rem;
          display: flex;
          flex-direction: column;
          border-radius: 6px;
          background-color: white;
          box-shadow: 0px 0px 2px 1px rgba(1, 1, 1, 0.1);
        }

        .designate-list-title {
          height: 1.875rem;
          line-height: 1.875rem;
          font-size: 0.625rem;
          color: #999;
          border-bottom: 1px solid #f3f3f3;
        }

        .designate-item {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 2.75rem;
          border-bottom: 1px solid #f3f3f3;
        }

        .designate-item-address {
          font-size: 0.875rem;
          font-weight: 550;
          color: #333;
        }
        .fixedImg {
          color: #666;
        }

        .designate-item .icon-you {
          position: absolute;
          right: 0;
        }
      }
      .myOrder_list {
        // max-height: 12rem;
        margin-top: 16px;
        // overflow-y: scroll;
        .classItem {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.5rem;
          border-radius: 4px;
          margin-bottom: 1rem;
          //   border: 1px solid;
          text-align: left;
          box-shadow: 0 1px 3px 0 rgba(196, 196, 196, 0.5);
          .floor {
            font-size: 14px;
            color: #666;
          }
          .time {
            font-size: 1rem;
            color: #333;
            margin-top: 5px;
          }
          .isClassing {
            font-size: 12px;
            color: #44d06e;
            margin-top: 10px;
          }
          .status-text-parent {
            .status-text-up-hint {
              color: #333;
              font-size: 0.625rem;
              padding: 3px 0.4375rem;
              margin-left: 0.625rem;
              background-color: #f1f1f1;
              border-radius: 0px 0.625rem 0.625rem 0.625rem;
            }
          }
          .down-piano-parent {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 5.3125rem;
            height: 2.3125rem;
            border-left: 1px solid #c5c5c5;
          }
          .down-piano-parent > div {
            font-size: 1rem;
            color: #0487fe;
            padding: 0.3125rem;
          }
          .otherStateBox{
            width: 5.3125rem;
            display: flex;
            flex-direction: column;
            align-items: center;

          }
          .orderStateBox{
            display: flex;
           align-items: center;
            justify-content: center;
          .orderStateIcon{
          display: block;
            width: .375rem;
            height: .375rem;
            border-radius: 1.5625rem;

            margin-right: .25rem;
          }
          }
          .orderStateText{

            font-size: .625rem;
          }
          .orderStateIconNormal{
            background-color: #60B3FF;
          }
          .orderStateTextNormal{
            color: #60B3FF;
          }
          .orderStateIconNo{
            background-color: red;
          }
          .orderStateTextNo{
            color: red;
          }
          .orderStateIconOk{
            background-color: #00D115;
          }
          .orderStateTextOk{
            color: #00D115;
          }
        }
      }
      .empty-appointment-parent {
        display: flex;
        flex-direction: column;
        border-radius: 0.375rem;
        // margin: 1rem;
        height: 7.5rem;
        background-color: #fafafa;
        justify-content: center;
        align-items: center;
        .empty-appointment-hint {
          font-size: 0.75rem;
          color: #999;
        }
      }
    }

    .more_tit {
      font-size: 18px;
      color: #333;
      font-weight: 550;
      text-align: left;
      padding: 1rem 1rem;
    }

    .use_record {
      padding: 0 1rem;

      .use_tit {
        height: 2.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.25rem 0;
        .use_left {
          color: #74b0f9;
          i {
            font-size: 1.25rem;
          }
        }
        .use_right {
          flex: 1;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #e1e1e1;
          padding: 0.5rem 0;
          margin-left: 1rem;
          .history_order_text {
            font-size: 1rem;
            color: #333;
          }
        }

        .history_look {
          font-size: 14px;
          color: #919191;
        }
      }
    }
  }
}
</style>
